import React, { useState, useRef } from 'react'
import * as styles from "./Gallery.module.scss";
import galleryImage1 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-1.jpg";
import galleryImage2 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-2.jpg";
import galleryImage3 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-3.jpg";
import galleryImage4 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-4.jpg";
import galleryImage5 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-5.jpg";
import galleryImage6 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-6.jpg";
import galleryImage7 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-7.jpg";
import galleryImage8 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-8.jpg";
import galleryImage9 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-9.jpg";
import galleryImage10 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-10.jpg";
import galleryImage11 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-11.jpg";
import galleryImage12 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-12.jpg";
import galleryImage13 from "../../../images/on-going-projects/srinivasa/gallery/Gallery-13.jpg";
import bgImage from "../../../images/on-going-projects/srinivasa/header-icon.png";
import ImageModal from "../enchanted/ImageModal";
import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons';

function Gallery() {
  const [activeGalleryImage, setActiveGalleryImage] = useState(0);
  const [activeGalleryImageMobile, setActiveGalleryImageMobile] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const galleryImages = [galleryImage1, galleryImage2, galleryImage3, galleryImage4, galleryImage5, galleryImage6, galleryImage7, galleryImage8, galleryImage9, galleryImage10, galleryImage11, galleryImage12, galleryImage13];
  
  const handlePrevious = () => {
    if (activeGalleryImage > 0) {
      setActiveGalleryImage(activeGalleryImage - 1);
    }
  };
  
  const handleNext = () => {
    if (activeGalleryImage < galleryImages.length - 1) {
      setActiveGalleryImage(activeGalleryImage + 1);
    }
  };

  const handlePreviousMobile = () => {
    if (activeGalleryImageMobile > 0) {
      setActiveGalleryImageMobile(activeGalleryImageMobile - 1);
    }
  };

  const handleNextMobile = () => {
    if (activeGalleryImageMobile < galleryImages.length - 1) {
      setActiveGalleryImageMobile(activeGalleryImageMobile + 1);
    }
  };
  
  const galleryDescriptions = [
    {
      title: "A Tall Statured Shining Star",
      description: "Like a refreshing lyrical Green Oasis, Baashyaam's Srinivasa springs to life in the heart of the concrete chaos of West Mambalam."
    },
    {
      title: "A Subtle Façade That Seamlessly Blends With The Surrounding",
      description: "The façade of the building is sleek and modern, interspersed with presence of greenery on all the floors and around the project."
    },
    {
      title: "Entrance Drop-Off",
      description: "Lush, shady canopies of trees flanked by a landscaped garden will greet guests"
    },
    {
      title: "Double-Height Entrance Lobby",
      description: "The access to the entrance building level is via a double height naturally lit entrance lobby."
    },
    {
      title: "Master Bedroom",
      description: "A Vaastu compliant spacious suite that reinforces maximum comfort and space"
    },
    {
      title: "Living Area",
      description: "The design intent is a magnified space that creates an aura of bigness"
    },
    {
      title: "Dining Area",
      description: "The earmarked space has provision for ample natural light and ventilation"
    },
    {
      title: "Kitchen",
      description: "A striking, fully functional kitchen with an adjoining utility area"
    },
    {
      title: "Sky Garden Deck",
      description: "A Podium level elevated green open terrace."
    },
    {
      title: "Rooftop Gymnasium",
      description: "Comes with a yoga room that takes care of the overall fitness of the residents"
    },
    {
      title: "Party Hall",
      description: "Perched at the top with panoramic views"
    },
    {
      title: "Rooftop Swimming Pool",
      description: "Take bracing laps overlooking the cityscape and lounge in soothing privacy of a green deck"
    },
    {
      title: "Association Room",
      description: "A tastefully designed space for residents to congregate"
    }
  ];

  return (
    <div className={styles.gallery} id="section-5">
      <div className={styles.heading}>
        <img src={bgImage} alt="Gallery" className={styles.bgImage} />
        <span>Gallery</span></div>
      <div className={styles.galleryContainerWebb}> 
        <div className={styles.galleryRow1}>
          <div className={styles.galleryCounterContainer}>
            <div className={styles.arrowContainer}>
              <LeftCircleFilled className={styles.arrow} onClick={handlePrevious} />
              <RightCircleFilled className={styles.arrow} onClick={handleNext} />
            </div>
            <div className={styles.galleryCounterRow}>
              {activeGalleryImage > 0 && (
                <span className={styles.galleryCounterItem}>
                  { activeGalleryImage - 1 < 9 ? `0${activeGalleryImage}` : activeGalleryImage}
                </span>
              )}
            </div>
            <div className={styles.galleryCounterRow}>
              <span className={styles.galleryCounterItem + ' ' + styles.active}>
                {activeGalleryImage < 9 ? `0${activeGalleryImage + 1}` : activeGalleryImage + 1}
              </span>
            </div>
            <div className={styles.galleryCounterRow}>
              {activeGalleryImage < galleryImages.length - 1 && (
                <span className={styles.galleryCounterItem}>
                  {activeGalleryImage + 1 < 9 ? `0${activeGalleryImage + 2}` : activeGalleryImage + 2}
                </span>
              )}
            </div>
          </div>
          <div className={styles.galleryItem}>
            {galleryImages.map((image, index) => (
              <div key={index} className={styles.galleryItemImageContainer} style={{ transform: `translateX(${activeGalleryImage * 100 * -1}%)`, transition: 'transform 0.5s ease' }}>
              <img src={image} alt="gallery image" onClick={() => {
                setSelectedImage(index + 1);
                setIsModalOpen(true);
              }} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.galleryRow2}>
          {
            galleryDescriptions.map((description, index) => (
              <div key={index} className={styles.galleryDescriptionContainer + ' ' + (index === activeGalleryImage ? styles.active : '')}>
                <div className={styles.galleryDescription}>{description.description}</div>
              </div>
            ))
          }
          <div className={styles.bottomBorder}></div>
          <div className={styles.verticalBorder}></div>
          <div className={styles.bottomBorder2}></div>
          <div className={styles.galleryTitleContainer}>
            {
              galleryDescriptions.map((description, index) => (
                <div key={index} className={styles.galleryTitle + ' ' + (index === activeGalleryImage ? styles.active : '')}>{description.title}</div>
              ))
            }
          </div>
        </div>
      </div>

      <div className={styles.galleryContainerMWeb}>
      <div className={styles.arrowContainerMobile}>
              <LeftCircleFilled style={{ opacity: activeGalleryImageMobile > 0 ? '1' : '0' }} className={styles.arrow} onClick={() => { activeGalleryImageMobile > 0 && handlePreviousMobile();}} />
              <RightCircleFilled style={{ opacity: activeGalleryImageMobile < galleryImages.length - 1 ? '1' : '0' }} className={styles.arrow} onClick={() => { activeGalleryImageMobile < galleryImages.length - 1 && handleNextMobile();}} />
            </div>
        <div className={styles.galleryItem}>
          {galleryImages.map((image, index) => (
            <div key={index} className={styles.galleryItemImageContainer} style={{ transform: `translateX(${activeGalleryImageMobile * 100 * -1}%)` }}>
            <img src={image} alt="gallery image" onClick={() => {
              setSelectedImage(index + 1);
              setIsModalOpen(true);
            }} />
            {/* <div className={styles.galleryDescription}>{galleryDescriptions[index].title}</div> */}
            </div>
          ))}
        </div>
      </div>

      {isModalOpen ? (
        <ImageModal
          imagesArray={galleryImages}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
          showModal={isModalOpen}
          setShowModal={setIsModalOpen}
          showDescription={true}
          descriptionArray={galleryDescriptions}
        />
      ) : null}
    </div>
  )
}

export default Gallery